import {AlertFillIcon} from '@primer/octicons-react'
import type {ConversationComment} from '../../page-data/payloads/conversation-comments'
import {CommentLayout} from './CommentLayout'
import {itemTypeName} from './utils/item-type-name'
import {Stack} from '@primer/react'

interface CommentErrorFallbackProps {
  id?: string
  tabIndex?: number
  className?: string
  item: ConversationComment
}

/**
 * Error fallback for a comment or review summary.
 */
export function ConversationItemFallback({item, ...props}: CommentErrorFallbackProps) {
  const typeName = itemTypeName(item)
  return (
    <CommentLayout
      {...props}
      header={
        <Stack padding="none" gap="condensed" direction="horizontal" align="center">
          <AlertFillIcon size="small" className="my-2 mx-1" />
          Failed to load {typeName.lowercase}
        </Stack>
      }
      className="color-fg-muted"
    >
      This {typeName.lowercase} cannot be displayed. Please reload the page to try again.
    </CommentLayout>
  )
}
